import { ModuleWithProviders, NgModule } from "@angular/core";
import { AifLocalePipe, BIF_LANG_RESOURCES } from "./pipe/aif-ui-common-locale.pipe";

@NgModule({
    declarations: [
        AifLocalePipe
    ],
    exports: [
        AifLocalePipe
    ]
})
export class AifUiCommonModule {
    static forRoot(resources?: any): ModuleWithProviders {
        return {
            ngModule: AifUiCommonModule,
            providers: [
                { provide: BIF_LANG_RESOURCES, useValue: resources || {} },
            ],
        };
    }
}